import { queryKeys } from '@/react-query/constants';
import { createFeatureApi } from '@/shared/api';

/** Rebate-policy CRUD — roots on queryKeys.rebatePolicies. INTERNAL — consumers use the exported hooks. */
export const rebatePoliciesApi = createFeatureApi(queryKeys.rebatePolicies);
